import React, { useState, useEffect } from "react";
import { Box, TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody} from "@mui/material";
import {useSelector} from "react-redux"
import KmTRSDetailDialog from "./KmTRSDetailDialog"
import api from "../../../API";
import CustomPagination from "../../component/common/CustomPagination";

export interface KmTransData{
  idx : number;
  crw_idx : number;
  topic_cd : string;
  data_type_cd : string;
  created_date : string;
  seq : string;
  mgm_pk : string;
  issue_date : string;
  writer_ko : string;
  writer_km : string;
  copyrighter_ko : string;
  copyrighter_km : string;
  org_ext : string;
  data_src : string;

  url: string;
  kwd_km: string;
  kwd_ko: string;
  kwd_en: string;
  title_km: string;
  title_ko: string;
  title_en: string;
  text_km: string;
  text_ko: string;
  text_en: string;

  wrd_cnt : string;
  file_size : string;
  
  prc_json : string;
  prc_yn : string;
  prc_date : string;
  
  isp1_user : string;
  isp1_yn : string;
  isp1_date : string;
  isp1_rsn : string;
  isp1_rsn_cd : string;

  trs_user : string;
  trs_yn : string;
  trs_date : string;
  
  isp2_user : string;
  isp2_yn : string;
  isp2_date : string;
  isp2_rsn : string;
  
  ins_date : string;

  instruction_yn : string;
}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const initialData = {
  idx : -1,
  crw_idx : -1,
  topic_cd : "",
  data_type_cd : "",
  created_date : "",
  seq : "",
  mgm_pk : "",
  issue_date : "",
  writer_ko : "",
  writer_km : "",
  copyrighter_ko : "",
  copyrighter_km : "",
  org_ext : "",
  data_src : "",

  url: "",
  kwd_km: "",
  kwd_ko: "",
  kwd_en: "",
  title_km: "",
  title_ko: "",
  title_en: "",
  text_km: "",
  text_ko: "",
  text_en: "",

  wrd_cnt : "",
  file_size : "",
  
  prc_json : "",
  prc_yn : "",
  prc_date : "",
  
  isp1_user : "",
  isp1_yn : "",
  isp1_date : "",
  isp1_rsn : "",
  isp1_rsn_cd : "",

  trs_user : "",
  trs_yn : "",
  trs_date : "",
  
  isp2_user : "",
  isp2_yn : "",
  isp2_date : "",
  isp2_rsn : "",
  
  ins_date : "",
  instruction_yn: "",
}

const KhmTRSListPage = (props:any) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  // const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const worker = auth.user.roles.filter((obj:any) => obj.role === 'KHM_TRS').map((info:any) => info.user_id)[0];   
  
  const [data, setData] = useState<KmTransData>();
  const [rowDetail, setRowDetail] = useState<KmTransData>({
    idx : -1,
    crw_idx : -1,
    topic_cd : "",
    data_type_cd : "",
    created_date : "",
    seq : "",
    mgm_pk : "",
    issue_date : "",
    writer_ko : "",
    writer_km : "",
    copyrighter_ko : "",
    copyrighter_km : "",
    org_ext : "",
    data_src : "",

    url: "",
    kwd_km: "",
    kwd_ko: "",
    kwd_en: "",
    title_km: "",
    title_ko: "",
    title_en: "",
    text_km: "",
    text_ko: "",
    text_en: "",

    wrd_cnt : "",
    file_size : "",
    
    prc_json : "",
    prc_yn : "",
    prc_date : "",
    
    isp1_user : "",
    isp1_yn : "",
    isp1_date : "",
    isp1_rsn : "",
    isp1_rsn_cd : "",

    trs_user : "",
    trs_yn : "",
    trs_date : "",
    
    isp2_user : "",
    isp2_yn : "",
    isp2_date : "",
    isp2_rsn : "",
    
    ins_date : "",
    instruction_yn: "",
  });

  // api 사용자 정보에서 페이지 정보를 담을 state
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const getKmIspWorkerList = async () => {
    setBackdrop(true)
    var result = await api.get("/gncWorkerList", {
      // params: {email:email,page:page,instruction_yn:instruction_yn}
      params: {email:email,role:'KHM_ISP'}
    });
    // console.log("result.data", result.data);
    let kmWorkList:any[] = []
    var datas = result.data.datas.map((worker:any) => {
      // // console.log(worker.name, worker.roles[0].user_id)
      kmWorkList.push({"name":worker.name,"user_id": worker.roles[0].user_id})
    })

    // console.log('kmWorkList',kmWorkList)
    // setKmWorkers(kmWorkList)
    setBackdrop(false)
  }
  
  const updateAfter = () => {
    // setData([]);
    props.kmWorkList(props.work_yn);
  }

  useEffect(() => {
    if(props.workList.datas != undefined){
      if(data == undefined){
        setData(props.workList.datas[0])
      }
    }
    if(props.workList.pagination != undefined){
      setPagination(props.workList.pagination)
    }
  },[props])

  return (
    <Box>
      {/* Task 단위 화면 */}
      <Box display="flex" justifyContent="center" >
        <Box sx={{padding:"20px 8px 8px 8px", width:"280px"}}>
          <Box display="flex">
            <Box><img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/km_flag.jpg'} /></Box>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Khmer 번역</Box>
          </Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
          <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
            <Table size="small" aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>번역</Box></TableCell>
                  
                </TableRow>
              </TableHead>
              <TableBody>
              {(props.workList.datas != undefined && props.workList.datas.length > 0) ? props.workList.datas.map((row:any, index:number) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' }}}
                  onClick={()=> {setData(row);}}
                >
                  <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                  <TableCell align="center">
                    <Box sx={{width:"58px",fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                        border: (row.trs_yn === "Y" ? "2px solid #498ad5" : "2px solid #bbb"), color:"#000" }}>
                      {(row.trs_yn === "Y" ? "완료" :"미작업")}
                    </Box>
                    </TableCell>
                  {/* <TableCell align="left">{row.concept_en}</TableCell> */}
                  {/* <TableCell align="left">
                    <Box sx={{width:"58px",fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                        border: (row.use_check === "F" ? "2px solid red" : (row.use_check === "T" ? "2px solid #498ad5" : (row.use_check === "C" ? "2px solid #27cc2f" : "#bbb"))), color:"#000" }}>
                      {(row.use_check === "T" ? "사용가능" : (row.use_check === "F" ? "사용불가" : (row.use_check === "C" ? "내용수정":"미분류")))}
                    </Box>
                  </TableCell> */}
                </TableRow>
                )):<TableRow><TableCell colSpan={3} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{marginTop:"12px"}}>
            {pagination !== undefined ? (
                <CustomPagination pagination={pagination} goPage={props.goPage} />
            ) : ""}
          </Box>
        </Box>
        <KmTRSDetailDialog
          // dialogOpen={dialogOpen}
          rowDetail={data}
          updateAfter={updateAfter}
        />
      </Box>
    </Box>


  );
};

export default KhmTRSListPage;
